var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonOutline = function SvgPersonOutline(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 9C20 11.7575 17.7575 14 15 14C12.2425 14 10 11.7575 10 9C10 6.2425 12.2425 4 15 4C17.7575 4 20 6.2425 20 9ZM18.6 9C18.6 10.9843 16.9843 12.6 15 12.6C13.0157 12.6 11.4 10.9843 11.4 9C11.4 7.0157 13.0157 5.4 15 5.4C16.9843 5.4 18.6 7.0157 18.6 9Z",
    fill: "#B0B5C4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88359 17.6997C10.4722 16.7574 12.6311 16.1016 14.9996 16.1016C17.3681 16.1016 19.5271 16.7574 21.1156 17.6997C21.9095 18.1706 22.5861 18.7281 23.0737 19.3377C23.5558 19.9404 23.8996 20.6548 23.8996 21.4181C23.8996 22.3626 23.1712 22.8878 22.5814 23.1539C21.9623 23.4333 21.1617 23.5947 20.342 23.6967C18.5623 23.9183 16.7571 23.9016 14.9669 23.9016C13.3465 23.9016 11.3024 23.9016 9.65726 23.6967C8.83749 23.5947 8.03695 23.4333 7.41779 23.1539C6.82807 22.8878 6.09961 22.3626 6.09961 21.4181C6.09961 20.6548 6.44339 19.9404 6.92549 19.3377C7.41316 18.7281 8.08971 18.1706 8.88359 17.6997ZM9.59785 18.9038C10.9673 18.0914 12.879 17.5016 14.9996 17.5016C17.1202 17.5016 19.0319 18.0914 20.4014 18.9038C21.0864 19.3101 21.6217 19.7638 21.9805 20.2123C22.343 20.6655 22.4996 21.0796 22.4996 21.4181C22.4996 21.6635 22.193 21.7933 22.0057 21.8778C21.5817 22.0691 20.9494 22.2103 20.169 22.3075C18.4471 22.5219 16.699 22.5016 14.9669 22.5016C13.3231 22.5016 11.3722 22.4995 9.83024 22.3075C9.04983 22.2103 8.41753 22.0691 7.99356 21.8778C7.80623 21.7933 7.49961 21.6635 7.49961 21.4181C7.49961 21.0796 7.65621 20.6655 8.01874 20.2123C8.37751 19.7638 8.91287 19.3101 9.59785 18.9038Z",
    fill: "#B0B5C4"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/person-outline.3a492145.svg";
export { ForwardRef as ReactComponent };